import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'

const HeaderSocials = () => {
  return (
    <div className='header__socials'>
        <a href='https://www.linkedin.com/in/miguel-disu-lord-92543b134/' target='_blank' rel="noreferrer"><BsLinkedin /></a>
        <a href='https://github.com/md-l' target='_blank' rel="noreferrer"><FaGithub /></a>
        {/* <a href='https://dribbble.com' target='_blank'></a> */}
    </div>
  )
}

export default HeaderSocials